import { render, staticRenderFns } from "./emailCampaign.vue?vue&type=template&id=40617c5e&scoped=true"
import script from "./emailCampaign.vue?vue&type=script&lang=js"
export * from "./emailCampaign.vue?vue&type=script&lang=js"
import style0 from "./emailCampaign.vue?vue&type=style&index=0&id=40617c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40617c5e",
  null
  
)

export default component.exports